import React, { useState, useEffect } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, Card, Badge, DropdownItem, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, UncontrolledTooltip, Alert, Spinner } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PaginationComponent,
    Row,
    Col,
    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableRow,
    DataTableItem,
} from "../../../components/Component";
import { Link } from "react-router-dom";
import { loginAxios } from '../../../config/axios.config';
import { useQuery, useMutation } from "@tanstack/react-query";
import { useSelector, useDispatch } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import './style.scss';

import SingleBarChart from './BarChart';
import NewPieChart from './NewPieChart';
import PieChartPro from './PieChartPro';
import StackedBarChartPro from './StackedBarChartPro';
import StackedBarChartProB from './StackedBarChartProB';
import StackedBarChartProGroup from './StackedBarChartProGroup';
import StackedBarChartProGroupQty from './StackedBarChartProGroupQty';


import StackedBarChartProReverseGroup from './StackedBarChartProReverseGroup';
import StackedBarChartProReverseGroupQty from './StackedBarChartProReverseGroupQty';

import axios from "axios";
import {checkAndClearExpiredData} from '../../../../src/utils/Utils'

const ReturnCancelCharts = () => {

    
    const [returnCancelData, setReturnCancelData] = useState({});

    

    const returnCancelAPI = async (param) => {
        try {
            const { data } = await loginAxios.get(`dashboard/order-return-cancel`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken'),
                    'Access-Control-Allow-Origin': '*'
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    
    const returnCancelAPICall = useMutation(returnCancelAPI, {        
        onSettled(data, error) {
            if (data) {         
                
                const now = new Date().getTime();
                const item = {
                    value: data?.data?.finalResponse,
                    timestamp: now
                };
                
                sessionStorage.setItem("RETURN_CANCEL_DATA", JSON.stringify(item));
                setReturnCancelData(data?.data?.finalResponse)
            }
        }
    })


    useEffect(() => {
        if(sessionStorage.getItem('RETURN_CANCEL_DATA') == null) {
            returnCancelAPICall.mutate();
        } else {
            setReturnCancelData(JSON.parse(sessionStorage.getItem('RETURN_CANCEL_DATA'))?.value);
        }        
    },[]);




    setInterval(() => {
        if(checkAndClearExpiredData('RETURN_CANCEL_DATA')) {
            returnCancelAPICall.mutate();
        }
    }, 3600000);


    const [sort, setSortState] = useState("revenue_wise");

const handleChangePeriod = (txt) => {
    setSortState(txt);
    
}

const [returnSort, setreturnSortState] = useState("return_revenue_wise");

const handleChangeReturnType = (txt) => {
    setreturnSortState(txt);
    
}

    return (<>
        
        <Head title="Charts"></Head>
        
        <Content>            
            <BlockHead size="sm">
                <BlockBetween>
                    <BlockHeadContent>
                        <BlockTitle>Cancellations And Returns</BlockTitle>
                        <ul className="list list-sm" id="list-note">
                        <li>This tab gives you a month-wise look at the breakup of the reasons for designer-cancellation and  client-returns. You can view this in terms of quantity and revenue </li>
                        <li>We expect you to take corrective actions to bring down the revenue loss due to cancellations and returns  </li>
                        <li>All graphs use the customer order-date as reference</li>                        
                      </ul>
                    </BlockHeadContent>
                </BlockBetween>
            </BlockHead>

            <Block>
                <Row>                            
            
                    <Col md="12">


                    <Card className="card-stretch mt-2  p-3">
                        <div>
                            <h5 style={{ textDecoration: 'underline', display: 'inline-block' }}>Cancellations By Designer (With Reason)</h5>

                            {(returnCancelAPICall?.isLoading ) ?
                            <div style={{ textAlign: 'center' }}>
                                <Spinner size="xl" color="light" />
                            </div>
                            :
                            <>
                            <div className="card-tools mr-n1" style={{ alignItems: 'center', display: 'inline-block', float: 'right' }}>
                                <ul className="btn-toolbar">
                                    <li>
                                        <UncontrolledDropdown direction="up">
                                            <DropdownToggle
                                                tag="a"
                                                href="#toggle"
                                                onClick={(ev) => ev.preventDefault()}
                                                className="link link-light link-sm dropdown-indicator bold-dropdown-txt"                                                
                                            >
                                                {sort == "revenue_wise" && 'Revenue'}
                                                {sort == "qty_wise" && 'Qty'}
                                            </DropdownToggle>

                                            <DropdownMenu right className="dropdown-menu-xs">

                                                <ul className="link-check chart-ul-items">
                                                    {/* <li>
                                                        <span>Order</span>
                                                    </li> */}
                                                    <li className={sort === "revenue_wise" ? "active" : ""}>
                                                        <DropdownItem
                                                            tag="a"
                                                            href="#dropdownitem"
                                                            onClick={(ev) => {
                                                                ev.preventDefault();
                                                                handleChangePeriod("revenue_wise");
                                                            }}
                                                        >
                                                            Revenue
                                                        </DropdownItem>
                                                    </li>
                                                    <li className={sort === "qty_wise" ? "active" : ""}>
                                                        <DropdownItem
                                                            tag="a"
                                                            href="#dropdownitem"
                                                            onClick={(ev) => {
                                                                ev.preventDefault();
                                                                handleChangePeriod("qty_wise");
                                                            }}
                                                        >
                                                            Qty
                                                        </DropdownItem>
                                                    </li>

                                                </ul>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </li>
                                </ul>
                            </div>

                            <div  className={`inactive-stacked-chart card-inner-group ${sort == "revenue_wise" ? "active-stacked-chart" : ""}`}>
                                <StackedBarChartProGroupQty chartData={returnCancelData?.groupedQtyData || []} percentArray={returnCancelData?.cancelPercentArray || []} />                                
                            </div> 

                            <div className={`inactive-stacked-chart card-inner-group ${sort == "qty_wise" ? "active-stacked-chart" : ""}`} >
                                <StackedBarChartProGroup chartData={returnCancelData?.groupedData || []} percentArray={returnCancelData?.cancelPercentArray || []} />                                
                            </div>

                            </>
                            }
                        </div>

                    </Card>


                    </Col>

                    <Col md="12">

                    <Card className="card-stretch mt-2  p-3">
                        <div>
                            <h5 style={{ textDecoration: 'underline', display: 'inline-block' }}>Client Returns (With Reason)</h5>

                            {(returnCancelAPICall?.isLoading ) ?
                            <div style={{ textAlign: 'center' }}>
                                <Spinner size="xl" color="light" />
                            </div>
                            :
                            <>
                            <div className="card-tools mr-n1" style={{ alignItems: 'center', display: 'inline-block', float: 'right' }}>
                                <ul className="btn-toolbar">
                                    <li>
                                        <UncontrolledDropdown direction="up">
                                            <DropdownToggle
                                                tag="a"
                                                href="#toggle"
                                                onClick={(ev) => ev.preventDefault()}
                                                className="link link-light link-sm dropdown-indicator bold-dropdown-txt"                                                
                                            >
                                                {returnSort == "return_revenue_wise" && 'Revenue'}
                                                {returnSort == "return_qty_wise" && 'Qty'}
                                            </DropdownToggle>

                                            <DropdownMenu right className="dropdown-menu-xs">

                                                <ul className="link-check chart-ul-items">
                                                    {/* <li>
                                                        <span>Order</span>
                                                    </li> */}
                                                    <li className={returnSort === "return_revenue_wise" ? "active" : ""}>
                                                        <DropdownItem
                                                            tag="a"
                                                            href="#dropdownitem"
                                                            onClick={(ev) => {
                                                                ev.preventDefault();
                                                                handleChangeReturnType("return_revenue_wise");
                                                            }}
                                                        >
                                                            Revenue
                                                        </DropdownItem>
                                                    </li>
                                                    <li className={returnSort === "return_qty_wise" ? "active" : ""}>
                                                        <DropdownItem
                                                            tag="a"
                                                            href="#dropdownitem"
                                                            onClick={(ev) => {
                                                                ev.preventDefault();
                                                                handleChangeReturnType("return_qty_wise");
                                                            }}
                                                        >
                                                            Qty
                                                        </DropdownItem>
                                                    </li>

                                                </ul>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </li>
                                </ul>
                            </div>

                            <div  className={`inactive-stacked-chart card-inner-group ${returnSort == "return_revenue_wise" ? "active-stacked-chart" : ""}`}>
                                <StackedBarChartProReverseGroupQty chartData={returnCancelData?.reverseGroupedQtyData || []} percentArray={returnCancelData?.reversePercentArray || []} />                                
                            </div> 

                            <div className={`inactive-stacked-chart card-inner-group ${returnSort == "return_qty_wise" ? "active-stacked-chart" : ""}`} >
                                <StackedBarChartProReverseGroup chartData={returnCancelData?.reverseGroupedData || []} percentArray={returnCancelData?.reversePercentArray || []} />                
                            </div>

                            </>
                            }
                        </div>

                    </Card>

                        {/* <Card className="card-stretch mt-2  p-3">
                            <h5 style={{textDecoration: 'underline'}}>Returns (With Reason)</h5>
                            {returnCancelAPICall?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                        :   <div className="card-inner-group">
                                <StackedBarChartProReverseGroupQty chartData={returnCancelData?.reverseGroupedQtyData || []} percentArray={returnCancelData?.reversePercentArray || []} />                                
                            </div>                        
                        }
                        </Card> */}
                    </Col>








                          
                    {/* <Col md="12">
                        <Card className="card-stretch mt-2  p-3">
                            <h5 style={{textDecoration: 'underline'}}>Cancellations By Designer (With Reason)</h5>
                            {returnCancelAPICall?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                        :   <div className="card-inner-group">
                                <StackedBarChartProGroup chartData={returnCancelData?.groupedData || []} percentArray={returnCancelData?.cancelPercentArray || []} />                                
                            </div>                        
                        }
                        </Card>
                    </Col> */}


                          
                    {/* <Col md="12">
                        <Card className="card-stretch mt-2  p-3">
                            <h5 style={{textDecoration: 'underline'}}>Returns (With Reason)</h5>
                            {returnCancelAPICall?.isLoading ? 
                            <div style={{textAlign: 'center'}}>                            
                                <Spinner size="xl" color="light" />
                            </div>                    
                        :   <div className="card-inner-group">
                                <StackedBarChartProReverseGroup chartData={returnCancelData?.reverseGroupedData || []} percentArray={returnCancelData?.reversePercentArray || []} />                                
                            </div>                        
                        }
                        </Card>
                    </Col> */}



                </Row>
            </Block>
        </Content>
        <ToastContainer />
    </>)
};

export default ReturnCancelCharts;